import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
    letter-spacing: 0.02rem;
  }

  body {
    background: var(--secondary-color);
    color: var(--tertiary-color);
    -webkit-font-smoothing: antialiased;

    > div {
      display: flex;
    }

    .toast-top-right  {
      display: flex;
      flex-direction: column !important;
    }
   }

  body, input, button {
    font-family: 'Roboto', sans-serif;

    font-size: 18px;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }

  button {
    text-transform: none !important;
  }
`;
